export default{
  namespaced: true,
  state:{
    tickets: []
  },
  getters : {},
  mutations:{
    ADD_TICKETS_TO_LIST(state,data){
      state.tickets = data
    }
  }
}